export default "__VITE_ASSET__C3cXc6yM__"